import React, { useRef, useEffect, useMemo, useState, createRef } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'
import { deepFind } from '../../utils/utils'
import { useVirtualList } from 'ahooks'

type Column = {
    title: string
    path: string
    sort?: boolean // TODO
}

type IProp = {
    height: number
    widthPercentFirstRow: number
    columns: Column[]
    rows: { [key: string]: string }[]
}

// TODO CHANGE dangerouslySetInnerHTML to other way
const SimpleTable = ({ height = 100, columns = [], rows = [], widthPercentFirstRow = 25 }: IProp) => {
    return (
        <Table style={{ height: `${height}%` }}>
            <Body>
                <Head>
                    {columns?.map(({ title }, index) => (
                        <HeadTd
                            key={index}
                            widthPercentFirstRow={widthPercentFirstRow}
                            dangerouslySetInnerHTML={{ __html: i18n(title) }}
                        />
                    ))}
                </Head>

                <div>
                    {rows.map((ele, index) => {
                        return (
                            <BodyTr key={index}>
                                {columns?.map(({ path }, indexColumn) => {
                                    return (
                                        <BodyTd widthPercentFirstRow={widthPercentFirstRow} key={indexColumn}>
                                            <span
                                                title={deepFind(ele, path)}
                                                className={indexColumn === 0 ? 'body-td-span-title' : 'body-td-span'}
                                                dangerouslySetInnerHTML={{
                                                    __html: i18n(deepFind(ele, path)) || ''
                                                }}
                                            />

                                            {indexColumn === 0 && (
                                                <div>
                                                    <LiveTooltip position="bottom" content={i18n(ele?.__tooltip)}>
                                                        <i className="far fa-info-circle" />
                                                    </LiveTooltip>
                                                </div>
                                            )}
                                        </BodyTd>
                                    )
                                })}
                            </BodyTr>
                        )
                    })}
                </div>
            </Body>
        </Table>
    )
}

export default SimpleTable

const Table = styled.div`
    .fa-info-circle {
        cursor: pointer;
        margin-left: 4px;
        font-weight: 400;
        color: ${({ theme }) => theme['gray-500']};
    }
`

const Head = styled.div`
    display: flex;
    align-items: end;
    position: sticky;
    top: 0;
    background: ${({ theme }) => theme['gray-0']};
`

const HeadTd = styled.div`
    display: flex;
    flex: 1;
    border: none;
    padding: 0 24px 8px 24px;
    font-family: ${({ theme }) => theme['font-semibold']};
    font-size: 12px;
    color: ${({ theme }) => theme['gray-800']};
    gap: 4px;
    text-transform: none;
    justify-content: center;
    overflow-x: hidden;

    &:nth-child(1) {
        width: ${({ widthPercentFirstRow }) => `${widthPercentFirstRow}%`};
        flex: auto;
    }
`

const Body = styled.div`
    height: 100%;
    overflow-y: auto;
    overflow-x: scroll;

    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme['gray-500']};
        border-radius: 10px;
    }
`

const BodyTr = styled.div`
    display: flex;
    align-items: center;
    font-family: ${({ theme }) => theme['font-regular']};

    &:nth-child(even) {
        background-color: ${({ theme }) => theme['gray-100']};
        border-radius: 10px;
    }
`

const BodyTd = styled.div`
    flex: 1;
    font-family: ${({ theme }) => theme['font-regular']};
    font-size: 14px;
    font-style: normal;
    line-height: normal;
    padding: 0 24px;
    height: 50px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    .body-td-span {
        text-overflow: ellipsis;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .body-td-span-title {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow-anchor: auto;
        overflow-x: hidden;
        height: 35%;
        text-align: left;
        align-content: center;
        max-width: calc(100% - 15px);
    }

    &:nth-child(1) {
        width: ${({ widthPercentFirstRow }) => `${widthPercentFirstRow}%`};
        flex: auto;
        color: #000;
        font-weight: 400;
        border-radius: 10px 0 0 10px;
        justify-content: flex-start;
    }

    &:nth-child(2) {
        font-weight: 600;
        color: ${({ theme }) => theme['gray-700']};
    }

    &:nth-child(3) {
        color: #929801;
        font-weight: 600;
    }

    &:nth-child(4) {
        font-weight: 400;
        color: ${({ theme }) => theme['gray-600']};
    }

    &:last-child {
        border-radius: 0 10px 10px 0;
    }
`
